import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'swiper/swiper-bundle.css'; // Core Swiper styles
import 'swiper/css/navigation'; // Navigation module styles  
import 'swiper/css/pagination'; // Pagination module styles
import 'swiper/css/scrollbar'; // Scrollbar module styles (if needed)
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
